var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cdu-header-component" }, [
    _c("div", { staticClass: "clock" }, [
      _vm.brand_white1 || _vm.brand_translux5
        ? _c("span", { staticClass: "date" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("moment")(
                    new Date(),
                    _vm.dateFormats.dayAndMonthInverse
                  )
                ) +
                "\n    "
            )
          ])
        : _vm.brand_translux3
        ? _c("span", { staticClass: "date" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("moment")(new Date(), _vm.dateFormats.dayMonthAndYear)
                ) +
                "\n    "
            )
          ])
        : _c("span", { staticClass: "date" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("moment")(new Date(), _vm.dateFormats.dayAndMonth)
                ) +
                "\n    "
            )
          ]),
      _vm._v(" "),
      _c("span", { staticClass: "time" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm._f("moment")(new Date(), _vm.dateFormats.shortTime)) +
            "\n      "
        ),
        _c("span", { staticClass: "time-suffix" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("moment")(new Date(), "A")) +
              "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("img", {
      staticClass: "logo",
      attrs: { src: "static/img/logo.png", alt: "Logo" }
    }),
    _vm._v(" "),
    (_vm.brand_white1 || _vm.brand_translux5) &&
    _vm.screenConfiguration.is2showeventsin2columns &&
    _vm.liveEventAppearsOnScreen
      ? _c("span", { staticClass: "live-icon" }, [_vm._v("LIVE")])
      : _vm._e(),
    _vm._v(" "),
    (_vm.brand_white1 || _vm.brand_translux5) &&
    _vm.screenConfiguration.is2showeventsin2columns &&
    _vm.screenIdFoSportTypes.length === 1
      ? _c(
          "span",
          { staticClass: "sport-icons" },
          [_c("sport-icon", { attrs: { event: _vm.cduNonPinnedEvents } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("span", {
      staticClass: "screen-message text-overflow",
      domProps: {
        innerHTML: _vm._s(_vm.screenConfiguration.topmarketinglinetext)
      }
    }),
    _vm._v(" "),
    _vm.currentRotateIndex !== undefined && _vm.maxRotationIndex !== undefined
      ? _c("span", { staticClass: "paging-index" }, [
          _vm._v(
            "PAGE " +
              _vm._s(_vm.currentRotateIndex + 1) +
              " of " +
              _vm._s(_vm.maxRotationIndex + 1)
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isDebug ? _c("div", { staticClass: "debug" }) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77114634", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77114634","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cdu/cduHeader.vue
// module id = null
// module chunks = 